<ng-container *ngIf="sidenavs">
  <ng-container *ngTemplateOutlet="withSidenavs"></ng-container>
</ng-container>

<ng-container *ngIf="!sidenavs">
  <ng-container *ngTemplateOutlet="noSidenavs"></ng-container>
</ng-container>

<ng-template #withSidenavs>
  <mat-sidenav-container autosize>
    <mat-sidenav-content class="vi-page flex flex-row lt-lg:flex-col">
      <div>
        <ng-content select="[stickyPanel]"></ng-content>
      </div>
      <div class="full-width flex flex-col" [ngClass]="{ 'margin-left': desktopMarginLeft }">
        <ng-container *ngTemplateOutlet="head"></ng-container>
        <ng-container *ngTemplateOutlet="body"></ng-container>
        <ng-container *ngTemplateOutlet="foot"></ng-container>
      </div>
    </mat-sidenav-content>
    <mat-sidenav
      #leftSidenav
      [mode]="sidenavMode"
      [opened]="opened"
      [autoFocus]="false"
      position="start"
    >
      <ng-content select="[left-sidenav]"></ng-content>
    </mat-sidenav>
    <mat-sidenav #rightSidenav [mode]="sidenavMode" [opened]="false" position="end">
      <ng-content select="[right-sidenav]"></ng-content>
    </mat-sidenav>
  </mat-sidenav-container>
</ng-template>

<ng-template #noSidenavs>
  <div class="vi-page flex flex-row lt-md:flex-col">
    <div>
      <ng-content select="[stickyPanel]"></ng-content>
    </div>
    <div class="full-width flex flex-col">
      <ng-container *ngTemplateOutlet="head"></ng-container>
      <ng-container *ngTemplateOutlet="body"></ng-container>
      <ng-container *ngTemplateOutlet="foot"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #head>
  <vi-head [fixed]="fixedHead" [isShadow]="shadowHead">
    <ng-content select="[head]"></ng-content>
  </vi-head>
</ng-template>

<ng-template #body>
  <vi-body
    [class.background-white]="isWhiteBackground"
    class="flex flex-col justify-between items-center"
  >
    <ng-content body select="[body]"></ng-content>
  </vi-body>
</ng-template>

<ng-template #foot>
  <vi-footer *ngIf="footer">
    <ng-content select="[footer]"></ng-content>
  </vi-footer>
</ng-template>
